import axios from 'axios'
import config from '../../utils/config'
import toast from 'react-hot-toast'

const url = config.testUrl

const register = async (adminData) => {
	const response = await axios.post(`${url}/admin/signin`, adminData)

	if (response.data) {
		// localStorage.setItem('admin', JSON.stringify(response.data.data))
		toast.success('details has been sent!', {
			position: 'top-right',
		})
	}
	return response.data.data
}

const login = async (adminData) => {
	const response = await axios.post(`${url}/admin/login`, adminData)

	return response.data.data
}

const authService = {
	register,
	login,
}

export default authService
